var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyNftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 14.9102H5.66667M10.3333 14.9102H12.6667M12.2778 3.76346V9.91341M1 3.53284L1 10.144C1 11.0051 1 11.4356 1.16955 11.7645C1.31868 12.0538 1.55665 12.289 1.84935 12.4364C2.1821 12.604 2.6177 12.604 3.48889 12.604L12.5111 12.604C13.3823 12.604 13.8179 12.604 14.1507 12.4364C14.4433 12.289 14.6813 12.0538 14.8305 11.7645C15 11.4356 15 11.0051 15 10.144V3.53284C15 2.67176 15 2.24123 14.8305 1.91234C14.6813 1.62304 14.4433 1.38784 14.1507 1.24043C13.8179 1.07286 13.3823 1.07286 12.5111 1.07286L3.48889 1.07286C2.6177 1.07286 2.1821 1.07286 1.84935 1.24043C1.55665 1.38784 1.31868 1.62304 1.16955 1.91234C1 2.24123 1 2.67176 1 3.53284ZM7.61111 6.83843C7.61111 7.89985 6.74055 8.76029 5.66667 8.76029C4.59278 8.76029 3.72222 7.89985 3.72222 6.83843C3.72222 5.77702 4.59278 4.91657 5.66667 4.91657C6.74055 4.91657 7.61111 5.77702 7.61111 6.83843Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyNftIcon);
export default __webpack_public_path__ + "static/media/my_nft_icon.039a02ecf3b02977466a7da0c6564102.svg";
export { ForwardRef as ReactComponent };